<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-rose">
    <mat-icon>delete</mat-icon>
  </div>
  <h2>{{ 'deleteOrder.title' | translate }}</h2>
</div>
<div mat-dialog-content>
  @if (error) {
    <div class="dialog-error">
      <p> {{ 'DATA_ERRORS.ERROR0' | translate }} : {{ error }}</p>
    </div>
  }
  <p class="m-0">{{ 'ADMIN.CONFIRM_DELETE_ORDER' | translate }} {{ order.transactionId }} </p>
</div>
@if (progress) {
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" [disabled]="progress">
    {{ 'ADMIN.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="edit()" [disabled]="progress">
    <mat-icon>delete</mat-icon>
    {{ 'COMMON.DELETE' | translate }}
  </button>
</div>
